import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./NearbyPlaces.css";

import airport from "../assets/airport.png";
import school from "../assets/school.png";
import main from "../assets/main.png";
import ringRoad from "../assets/ringrad.png";
import shoppingMall from "../assets/shopping-mall.png";
import park from "../assets/park.png";
import foodStreet from "../assets/food-street.png";
import uni from '../assets/uni.png'

const nearbyPlaces = [
  {
    name: "Airport",
    image: airport,
  },
  {
    name: "Main Boulevard",
    image: main,
  },
  {
    name: "Hospital",
    image:
      "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=1600&q=70",
  },
  {
    name: "Ring Road",
    image: ringRoad,
  },
  {
    name: "School / College",
    image: school,
  },
  {
    name: "Universit",
    image: uni,
  },
  {
    name: "Shopping Mall",
    image: shoppingMall,
  },
  {
    name: "Park",
    image: park,
  },
  {
    name: "Food Street",
    image: foodStreet,
  },
];

const NearbySlider = () => {
  const { ref, inView } = useInView({ threshold: 0.14, triggerOnce: true });

  return (
    <section className="nbs" id="nearby" ref={ref}>
      <div className="nbs__container">
        <motion.div
          className="nbs__head"
          initial={{ opacity: 0, y: 14 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <div className="nbs__kicker">NEARBY PLACES</div>
          <h2 className="nbs__title">Everything you need, around you.</h2>
          <p className="nbs__sub">
            Just a quick view of nearby hotspots. (Replace demo images with your
            real nearby locations later.)
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7, delay: 0.08 }}
        >
          <Swiper
            modules={[ Pagination, Autoplay]}
          
            pagination={{ clickable: true }}
            autoplay={{ delay: 2600, disableOnInteraction: false }}
            spaceBetween={12}
            slidesPerView={1}
            breakpoints={{
              520: { slidesPerView: 2 },
              920: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            className="nbs__swiper"
          >
            {nearbyPlaces.map((p, idx) => (
              <SwiperSlide key={idx}>
                <div className="nbs__card">
                  <img className="nbs__img" src={p.image} alt={p.name} />
                  <div className="nbs__overlay" />
                  <div className="nbs__name">{p.name}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </section>
  );
};

export default NearbySlider;
